import {
    GET_MODULES,
    MOD_LOADING,
    UPDATE_MODULE,
} from "../actions/ModulesActions"

const initialState = {
    modules: [],
    module: [],
    updateModule: null,
    loading: true,
    success: false
};

const ModulesReducer = function(state = initialState, action){
    switch (action.type) {
        case MOD_LOADING: {
            return {
              ...state,
              loading: true,
              success: false,
            }
        }
        case GET_MODULES: {
            return {
                ...state,
                modules: [...action.data],
                loading: false
            }
        }
        case UPDATE_MODULE: {
            return {
                ...state,
                updateModule : action.data,
                success: true,
                loading: false
            }
        }
        default: {
            return state;
        }
    }
}

export default ModulesReducer;


